import { Money } from '@libs/money/money.interfaces';
import { Payment } from '@/api/Cart/cart.interfaces';
import { AdyenMoney } from './payment';
import { AgeRangeDefinitionsResult, Gender } from '@/api/Checkout/checkout.interfaces';

export interface PaymentEndpoint {
    GetDetails(adyenData: any): Promise<any>;
    GetPaymentMethods(amount: AdyenMoney): Promise<any>;
    GetPaymentContent(bookingToken?: string): Promise<StaticPaymentContent>;
    SubmitPayment(adyenData: any, cartPayment: Payment): Promise<any>;
    RedeemGiftCard(
        giftCardCode: string,
        cvc: string,
        isPartPayment: boolean,
        bookingToken: string
    ): Promise<GiftCardResponse>;
}

export interface StaticPaymentContent {
    BookingNumber: number | null;
    BookingPageUrl: string;
    GenderTitles: Gender;
    AgeRangeDefinitions: AgeRangeDefinitionsResult | null;
}

export interface GiftCardResponse {
    Balance: Money | null;
    Error: GiftCardErrorType | null;
    PaymentId?: string;
    NextUrl?: string | null;
}

export enum GiftCardErrorType {
    Invalid = 1,
    NoBalance = 2,
    ProductNotSupported = 3,
    RequiresCvc = 4,
    IncorrectCvc = 5,
}
